<template>
  <div class="casexPc">
    <div class="casexPchead">
      <div class="block">
        <el-carousel arrow="always" trigger="click" height="675px">
          <el-carousel-item v-for="(item, index) in swipeerImg" :key="index">
            <div class="block_swiperimg">
              <img
                :src="
                  item.img +
                  '?x-oss-process=image/interlace,1/resize,m_lfit,w_1920,h_1920/format,webp'
                "
                alt
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- <iframe src="https://meta-test.mrstage.com" ref="meta" width="100%" height="1200" allow="microphone *;camera *;display-capture *"></iframe> -->
    <!-- <iframe src="https://forexe.mrstage.com" ref="forexe" width="100%" height="1200" allow="microphone *;camera *;display-capture *"></iframe> -->
    <div class="casexPccontent">
      <div class="caseallContent_box">
        <div class="caseallTitle">
          <!-- <div>全部案例</div> -->
          <!-- <div>
            可帮助各行业创造优质3D数字内容和顶尖的互动式线上虚拟活动体验
          </div> -->
        </div>
        <div class="caseallContent">
          <div
            class="caseItem"
            v-for="(item,index) in caseList"
            @click="handleCasebilibilipcdetails(item)"
            :key="index"
          >
            <img class="coverImg" :src="item.coverImg" alt />
            <div class="caseItmeintroduce">
              <div class="caseitemName">
                <img
                  v-show="item.imgIcon !== ''"
                  :src="
                    item.imgIcon +
                    '?x-oss-process=image/interlace,1/resize,m_lfit,w_1920,h_1920/format,webp'
                  "
                  alt
                />
                <div>{{ item.name }}</div>
              </div>
              <div class="caseitemTitle">{{ item.introduce }}</div>
              <div class="caseitemText">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from './caselist'
// import { getDataList} from './api'
export default {
  data() {
    return {
      swipeerImg: [
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/1%402x.png'
        },
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/2%402x.png'
        },
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/3%402x.png'
        },
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/4%402x.png'
        },
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/5%402x.png'
        },
        {
          img: 'https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20230110/6%402x.png'
        }
      ],
      caseList: []
    }
  },
  created() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.$router.push({
        path: '/caseeducation/index'
      })
      return true
    }
  },
  mounted() {
    this.caseList = list
    this.caseList.map((item,index) =>{
      item.id = index
    })
    // fetch("https://case-test.mrstage.com//mrstage-base/caseConfig/findCaseConfigList", {
    //     method: "get",
    //   })
    //     .then(res => {
    //       return res.json(); // 返回一个Promise，可以解析成JSON
    //     })
    //     .then(res => {
    //       console.log(res);
    //       if (res.data) {
    //         this.caseList = res.data
    //       }
    //     });
  },
  methods: {
    //跳转详情
    handleCasebilibilipcdetails(item) {
      let routeUrl = this.$router.resolve({
        path: '/caseeducation/details',
        query: item 
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang='less' scoped>
.casexPc {
  width: 100%;
  height: 100%;
  .casexPchead {
    min-width: 1200px;
    width: 100%;
    display: flex;
    justify-content: center;
    height: 675px;
    .block {
      width: 1200px;
      .block_swiperimg {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
  .casexPccontent {
    width: 100%;
    display: flex;
    justify-content: center;
    min-width: 1200px;
    .caseallContent_box {
      width: 1212px;
      margin-top: 45px;
      .caseallTitle {
        div:nth-child(1) {
          font-size: 32px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          margin-bottom: 20px;
          color: #40445e;
        }
        div:nth-child(2) {
          font-size: 20px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #9c9ca0;
        }
      }
      .caseallContent {
        width: 1212px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 60px;
        .caseItem {
          width: 285px;
          transition: all 0.6s;
          border-radius: 8px;
          margin-right: 24px;
          margin-bottom: 40px;
          background-color: #fff;
          overflow: hidden;
          position: relative;
          .coverImg {
            width: 100%;
            height: 161px;
            cursor: pointer;
          }
          &:hover {
            transform: scale(1.1);
          }
          .caseItmeintroduce {
            width: 100%;
            padding: 16px;
            .caseitemName {
              display: flex;
              align-items: center;
              margin-bottom: 16px;
              img {
                width: 20px;
                height: 20px;
                margin-right: 8px;
              }
            }
            .caseitemTitle {
              font-size: 17px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #25293f;
              margin-bottom: 26px;
            }
            .caseitemText {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #9c9ca0;
              position: absolute;
              bottom: 10px;
            }
          }
        }
        .caseItem:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
